import { render, staticRenderFns } from "./SoftwareBugTemplate.vue?vue&type=template&id=e0c207fe&scoped=true"
import script from "./SoftwareBugTemplate.vue?vue&type=script&lang=js"
export * from "./SoftwareBugTemplate.vue?vue&type=script&lang=js"
import style0 from "./SoftwareBugTemplate.vue?vue&type=style&index=0&id=e0c207fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c207fe",
  null
  
)

export default component.exports